import type { CINTLocale } from '../types/cint';
import { cintLanguageMap } from '../locales';


const languageMapEntries = Object.entries(cintLanguageMap);

export const getMappedCountryLanguages = (countries?: CINTLocale[], countryId?: string) => {
  if (!countryId) {
    return;
  }

  const country = countries?.find((locale) => locale.country.code === countryId);
  const sortedLanguages = country?.languages?.sort(
    (a, b) => {
      const isPreferredDifference = Number(Boolean(b.is_preferred)) - Number(Boolean(a.is_preferred));
      if (isPreferredDifference === 0) {
        //  sort alphabetically
        return a.name.localeCompare(b.name);
      }

      return isPreferredDifference;
    }
  );

  const mappedLanguages = sortedLanguages?.map((language) => {
    const locale = `${countryId}_${language.code}`;
    const cintLanguageByLocale = languageMapEntries.find(([, value]) => value === locale);
    const cintLanguageByLangCode = languageMapEntries.find(([, value]) => value === language.code);

    return cintLanguageByLocale?.[0] ?? cintLanguageByLangCode?.[0];
  });
  const filteredLanguages = mappedLanguages?.filter(Boolean) as string[] | undefined;

  if (filteredLanguages && filteredLanguages.length > 0) {
    return filteredLanguages;
  }

  return;
};
